var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LoginPage',{attrs:{"showTitle":_vm.showTitle},on:{"swicthPage":_vm.swicthPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }